export default "__VITE_ASSET__BD$fKx6d__"